import React from 'react';
import { Container, FeedbackTitle, Subtitle, CheckIcon } from './Styled';

export const SuccessFeedback = () => (
  <Container>
    <CheckIcon />
    <FeedbackTitle>Sua pergunta foi enviada!</FeedbackTitle>
    <Subtitle>A gente te avisa quando ela for respondida, tá? :)</Subtitle>
  </Container>
);

export default SuccessFeedback;
